<template>
  <transition name="page-toggle">
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RouteView',
  computed: {
    multipage() {
      return this.$store.state.setting.multipage
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/layouts/RouteView.vue